import React from 'react';
import PropTypes from 'prop-types';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';

class ProductModalPermissions extends React.Component{

    state = {
        tagsForAccess: this.props.product.tagsForAccess ? this.props.product.tagsForAccess.split(',') : [],
        tagsForDenyAccess: this.props.product.tagsForDenyAccess ? this.props.product.tagsForDenyAccess.split(',') : []
    };

    handleChange = (tags, key) => {
        this.setState({[key]: tags});
        this.props.updateProduct(key, tags.join(','));
    };

    render() {
        console.log(this.state.tagsForDenyAccess);
        return (
            <div className="tab-panel">
                <div className="column">
                    <label>Show to users with these tags</label>
                    <TagsInput value={this.state.tagsForAccess[0] === "" ? [] : this.state.tagsForAccess} onChange={tags => this.handleChange(tags, 'tagsForAccess')} />
                </div>
                <div className="column">
                    <label>Hide from users with these tags</label>
                    <TagsInput value={this.state.tagsForDenyAccess[0] === "" ? [] : this.state.tagsForDenyAccess} onChange={tags => this.handleChange(tags, 'tagsForDenyAccess')} />
                </div>
            </div>
        );
    }
}

ProductModalPermissions.propTypes = {
    product: PropTypes.object.isRequired,
    updateProduct: PropTypes.func.isRequired
}

export default ProductModalPermissions;


/** WEBPACK FOOTER **
 ** ./src/components/ProductModalPermissions.js
 **/